import angular from 'angular';
import template from './template.html';
import './style.scss';

export class CandidatesListItemLoading {
    $onChanges() {
    }
}

export const CandidatesListItemLoadingConfiguration = {
    template,
    bindings: {},
    controller: CandidatesListItemLoading,
    controllerAs: 'candidatesListItemLoadingCtrl',
};

angular.module('TALENYA-FE').component('candidatesListItemLoading', CandidatesListItemLoadingConfiguration);
